import type { AnchorDefined, AnchorTypes } from "@saberhq/anchor-contrib";
import type { PublicKey } from "@solana/web3.js";

import type { ActivityIDL } from "../idls/activity";

export * from "../idls/activity";

export type ActivityTypes = AnchorTypes<
  ActivityIDL,
  {
    activityMaster: ActivityMasterData;
    activityMetadata: ActivityMetaData;
  }
>;

type Accounts = ActivityTypes["Accounts"];

export type ActivityMasterData = Accounts["ActivityMaster"];
export type ActivityMetaData = Accounts["ActivityMetadata"];

export type ActivityError = ActivityTypes["Error"];
export type ActivityProgram = ActivityTypes["Program"];

export type ActivityDefs = AnchorDefined<ActivityIDL>;

export interface ActivityMasterInfo extends ActivityMasterData {
  address: PublicKey;
}
